import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { createStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import { default as MuiDivider } from '@material-ui/core/Divider';
export var styles = function () {
    var iconSpacing = 24;
    return createStyles({
        insetSmall: {
            marginLeft: 16 + iconSpacing,
        },
        insetMedium: {
            marginLeft: 24 + iconSpacing,
        },
        insetLarge: {
            marginLeft: 38 + iconSpacing,
        },
        insetXLarge: {
            marginLeft: 42 + iconSpacing,
        },
    });
};
export var Divider = React.forwardRef(function (props, ref) {
    var classes = props.classes, className = props.className, insetSmall = props.insetSmall, insetMedium = props.insetMedium, insetLarge = props.insetLarge, insetXLarge = props.insetXLarge, other = __rest(props, ["classes", "className", "insetSmall", "insetMedium", "insetLarge", "insetXLarge"]);
    var classNames = clsx(insetSmall && classes.insetSmall, insetMedium && classes.insetMedium, insetLarge && classes.insetLarge, insetXLarge && classes.insetXLarge, className);
    return React.createElement(MuiDivider, __assign({ className: classNames, ref: ref }, other));
});
export default withStyles(styles)(Divider);
//# sourceMappingURL=Divider.js.map